<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">İzin Türü</label>
            <v-select-list v-model="type" label="Name" placeholder="İzin Türü" :options="types"/>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Talep Tarihi</label>
            <v-date-picker type="datetime" v-model="value.RequestDate" placeholder="Talep Tarihi"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Başlangıç Tarihi</label>
            <v-date-picker type="datetime" v-model="value.StartDateTime" placeholder="Başlangıç Tarihi"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Bitiş Tarihi</label>
            <v-date-picker type="datetime" v-model="value.EndDateTime" placeholder="Bitiş Tarihi"></v-date-picker>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">İş Başı Tarihi</label>
            <v-date-picker type="datetime" v-model="value.JobStartDateTime" :disabled="!value.EndDateTime" :disabled-date="disabledDate" placeholder="Bitiş Tarihi"/>
        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea v-model="value.Description" placeholder="Açıklama" class="form-control resize-none"></textarea>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    props:{
        value:Object,
    },
    watch:{
        "value.EndDateTime"(val){
            if(val){
                if(moment(val,'YYYY-MM-DD HH:mm').isValid()){
                    this.value.JobStartDateTime = moment(val,'YYYY-MM-DD HH:mm').add(1,'days').format('YYYY-MM-DD HH:mm')
                }else this.value.JobStartDateTime = null
            }else this.value.JobStartDateTime = null
        }
    },
    mounted(){
        this.getExcuseTypes()
    },
    data(){
        return {
            types:[]
        }
    },
    methods:{
        disabledDate(date){
            if(this.value.EndDateTime){
                let startDate = moment(this.value.EndDateTime,'YYYY-MM-DD HH:mm')
                let currentDate = moment(date)
                if(currentDate.isSameOrBefore(startDate)) return true
                else return false
            }else return false
        },
        getExcuseTypes(){
            EmployeeOperationsApi.ExcuseType.List().then(res=>{
                this.types = res.data.Data
            })
        },
    },
    computed:{
        type:{
            get:function(){
                return this.types.find(b=>b.Id==this.value.ExcuseTypeId)
            },
            set:function(value){
                this.value.ExcuseTypeId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>